// 环境配置管理
const env = '4'; // 1:本地 2:测试 3:验证 4:生产

let urlConfig = {
  env
};

switch (env) {
  case '1': //本地
    urlConfig.baseUrl = 'http://localhost:8961/uniDoc/'; //接口地址
    urlConfig.title = '车辆检测报告管理系统-本地环境';
    urlConfig.timeout = 10000;
    urlConfig.debug = true;
    break;
  case '2': //测试
    urlConfig.baseUrl = 'http://localhost:8961/uniDoc/'; //接口地址
    urlConfig.title = '车辆检测报告管理系统-测试环境';
    urlConfig.timeout = 12000;
    urlConfig.debug = true;
    break;
  case '3': //验证
    urlConfig.baseUrl = ''; //接口地址
    urlConfig.title = '车辆检测报告管理系统-验证环境';
    urlConfig.timeout = 15000;
    urlConfig.debug = false;
    break;
  case '4': //生产
    urlConfig.baseUrl = 'https://www.zccar.cloud/uniDoc/'; //接口地址
    urlConfig.title = '车辆检测报告管理系统';
    urlConfig.timeout = 10000;
    urlConfig.debug = false;
    break;
}

// 环境配置对象
const config = {
  // 当前环境
  env: urlConfig.env,
  
  // API配置
  baseUrl: urlConfig.baseUrl,
  timeout: urlConfig.timeout,
  
  // 应用配置
  title: urlConfig.title,
  
  // 调试配置
  debug: urlConfig.debug,
  
  // 环境判断
  isLocal: env === '1',
  isTest: env === '2',
  isVerify: env === '3',
  isProduction: env === '4',
  
  // 获取环境信息
  getEnvInfo() {
    return {
      env: this.env,
      baseUrl: this.baseUrl,
      timeout: this.timeout,
      title: this.title,
      debug: this.debug
    }
  }
}

export default config 